import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import AuthContext from 'helpers/authContext';
import { useQueryString } from 'helpers/effects';
import PromotedAdPackagesList from 'components/PromotedAdPackages/List';

const ScreenPromotedAdPackagesList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <AuthContext.Consumer>
          {value => (
            <PromotedAdPackagesList
              me={value}
              initialFilters={initialFilters}
            />
          )}
        </AuthContext.Consumer>
      </GridItem>
    </GridContainer>
  );
};

export default ScreenPromotedAdPackagesList;
